import { faHome, faCar, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactComponentElement } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './styles/header.scss';
import { Button, Tooltip } from 'antd';
import { MY_CAR_URL } from '../../utils/envVars';

interface HeaderProps {
  title: string;
  actions?: ReactComponentElement<any>;
}

const Header = ({ title, actions }: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onHomeClick = (e: any) => {
    navigate('/', { replace: location.pathname === '/' });
  };

  const onCarTrackerClick = () => {
    window.location.href = MY_CAR_URL;
  };

  const onRefreshClick = () => {
    window.location.reload();
  };

  return (
    <div className="header__container">
      <div className="header__section">
        <Button
          shape="circle"
          type="link"
          icon={<FontAwesomeIcon icon={faHome} color="white" />}
          onClick={onHomeClick}
          className="header__home-button"
        />
        <Tooltip title="Car Tracker">
          <Button
            shape="circle"
            type="link"
            icon={<FontAwesomeIcon icon={faCar} color="white" />}
            onClick={onCarTrackerClick}
            className="header__home-button"
          />
        </Tooltip>
        <Tooltip title="Refresh">
          <Button
            shape="circle"
            type="link"
            icon={<FontAwesomeIcon icon={faRotateRight} color="white" />}
            onClick={onRefreshClick}
            className="header__home-button"
          />
        </Tooltip>
      </div>
      <div className="header__section">{title}</div>
      <div className="header__section">{actions}</div>
    </div>
  );
};

export default Header;
